class TabbedCollection extends HTMLElement {
  constructor() {
    super();
    this.swipers = {};
    this.currentTab = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    Object.values(this.swipers).forEach((swiper) => {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
  }

  init() {
    this.tabs = this.querySelectorAll('.tabbed-collection__tab');
    this.panels = this.querySelectorAll('.tabbed-collection__panel');
    this.enableSwiper = this.dataset.enableSwiper === 'true';

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      if (index === 0) {
        tab.classList.add('active');
        this.currentTab = index;
      }
    });

    this.panels.forEach((panel, index) => {
      if (index === 0) {
        panel.classList.add('active');
      }
      if (this.enableSwiper) {
        this.initSwiper(panel, index);
      }
    });
  }

  switchTab(index) {
    if (index === this.currentTab) return;

    this.tabs.forEach((tab) => tab.classList.remove('active'));
    this.panels.forEach((panel) => panel.classList.remove('active'));

    this.tabs[index].classList.add('active');
    this.panels[index].classList.add('active');

    this.currentTab = index;

    if (this.swipers[index]) {
      setTimeout(() => {
        this.swipers[index].update();
      }, 300);
    }
  }

  initSwiper(panel, index) {
    const swiperContainer = panel.querySelector('.swiper');
    if (!swiperContainer) return;

    const nextEl = panel.querySelector('.swiper-button-next');
    const prevEl = panel.querySelector('.swiper-button-prev');
    const paginationEl = panel.querySelector('.swiper-pagination');

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded');
      swiperContainer.style.visibility = 'visible';
      swiperContainer.style.opacity = '1';
      return;
    }

    if (this.swipers[index]) {
      this.swipers[index].destroy(true, true);
    }

    this.swipers[index] = new Swiper(swiperContainer, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : {},
      pagination: paginationEl ? { el: paginationEl, type: 'progressbar' } : {},
      breakpoints: {
        750: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      on: {
        init: function () {
          this.el.style.visibility = 'visible';
          this.el.style.opacity = '1';
        },
      },
    });
  }
}

if (!customElements.get('tabbed-collection')) {
  customElements.define('tabbed-collection', TabbedCollection);
}

document.addEventListener('shopify:section:load', function (event) {
  const tabbedCollections = event.target.querySelectorAll('tabbed-collection');
  tabbedCollections.forEach((element) => {
    element.init();
  });
});

document.addEventListener('shopify:section:unload', function (event) {
  const tabbedCollections = event.target.querySelectorAll('tabbed-collection');
  tabbedCollections.forEach((element) => {
    element.disconnectedCallback();
  });
});
